export default "__VITE_ASSET__lHrJMVoS__"